<template>
    <div class="tw-flex tw-flex-wrap tw-gap-3 tw-mt-2">
            <div class="tw-w-full md:tw-w-1/5">
                <v-text-field
                    v-model="value.search"
                    label="Search Members"
                    outlined
                    dense
                    append-icon="mdi-magnify"
                    clearable
                ></v-text-field>
            </div>

        <v-select class="tw-w-full md:tw-w-1/5"
                  label="Region"
                  :items="values_regions"
                  v-model="filters.region"
                  multiple
                  outlined
                  dense
                  clearable
        ></v-select>

        <v-select class="tw-w-full md:tw-w-1/5"
                  label="Province / States"
                  :items="valuelists.PROVINCES"
                  v-model="filters.province"
                  multiple
                  outlined
                  dense
                  clearable
        ></v-select>

            <v-autocomplete class="tw-w-full md:tw-w-1/5"
                label="Job Category"
                :items="values_categories"
                v-model="filters.category"
                multiple
                outlined
                dense
                clearable
            ></v-autocomplete>

        </div>
</template>

<script>

    export default {
        name: "AvailabilityReportFilters",
        props: {
            'value': {
                type: Object,
                required: true
            },
            'constants': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'valuelists': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
        },
        data() {
            return {
                filters: {
                    search: null,
                    region: undefined,
                    category: undefined,
                    skill: undefined,
                    province: undefined,
                },
                fetch_data_response: null,
            }
        },
        computed: {
            values_regions() {
                if (this?.constants?.MEMBER_REGIONS) {
                    return Object.values(this.constants?.MEMBER_REGIONS)
                }
                return []
            },
            values_categories() {
                if (this?.valuelists?.TITLE_FUNCTIONS_WEBSITE) {
                    return Object.values(this.valuelists?.TITLE_FUNCTIONS_WEBSITE)
                }
                return []
            },
            values_skills() {
                if (this?.valuelists?.SKILLS_GROUPED) {
                    return Object.values(this.valuelists?.SKILLS_GROUPED)
                }
                return []
            },
        },
        methods: {
            example() {
                console.log("This is just a test")
            },
        },
        watch: {
            value: {
                handler(newVal, oldVal) {
                    this.$emit('input', this.filters)
                },
                deep: true,
                immediate: true,
            },
        },
    }
</script>

<style>
</style>
